import { coreInitiativesLinksGetAsyncSlice } from './get';
import { CoreInitiativesLinksName } from './name';
import { createUpdateCollectionSyncSlice } from '@sonar-software/xuder';
import { PatchInitiativeLinkRequest } from '@api';

export const coreInitiativesLinksUpdateSyncSlice = createUpdateCollectionSyncSlice({
	hasRequest: true,
	name: CoreInitiativesLinksName,
	state: coreInitiativesLinksGetAsyncSlice.asyncState,
	target: (request: PatchInitiativeLinkRequest) => (link) => link.id === request.id,
	update: (request: PatchInitiativeLinkRequest) => (link) => ({
		...link,
		title: request.title ?? '',
		url: request.url ?? ''
	})
});
